import styled from 'styled-components';

export const SupportingDocumentMainWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 3.5rem;
    `
)

export const KycDocumentWrap = styled.div(
    props => `
        width:58%;
        display: flex;
        flex-direction: column;

        @media(max-width:1023px){
            width:100%;
        }
    `
);

export const InfoNoteText = styled.p(
    props => `
      font-size: ${props.theme.spacing.base};
      color: ${props.theme.colors.black.base};
    `
);

export const KycUploadDocumentWrap = styled.div(
    props => `
        width:40%;
        display: flex;
        flex-direction: column;
        padding-top:2rem;
        @media(max-width:1023px){
            width:100%;
            margin-top:1rem;
        }
    `
);

export const KYCUploadLabel = styled.label(
    props =>`
        width: 100%;
        display: flex;
        border: 1px dashed ${props.theme.colors.blue.light36};
        background-color: ${props.theme.colors.blue.light06};
        height: 4.2rem;
        border-radius: ${props.theme.misc.borderRadius.base};
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: pointer;
        margin-top:2rem;
        @media only screen and (min-width: 320px) and (max-width: 767px) {
        margin-top: ${props.theme.spacing.base};
        width: 100%;
        margin-left: 0rem;
        height: 6rem;
        }
`);
  
export const UploadImgMainText = styled.p(
    props => `
          display:inline-block;
          font-size: ${props.theme.font.large.font14};
          color: ${props.theme.colors.grey.base};
          text-align:center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width:95%;
      `,
);

export const BoldText = styled.span(
    props => `
        font-weight: ${props.theme.font.fontWeight.black};
        padding-left: ${props.theme.spacing.small.s3};
        padding-right: ${props.theme.spacing.small.s3};
    `,
);

export const SubInfoText = styled.span(
    props => `
        font-size: 1.2rem ${props.theme.font.base};
        color: ${props.theme.colors.grey.light07};
        padding-top:${props.theme.spacing.small.s3};
    `,
);

export const UploadFile = styled.input.attrs({type: 'file'})(
    props => `
        width:100%;
        display: flex;
        -webkit-appearance:none;
        display:none;
    `,
);

export const KycLabelWrap = styled.div(
    props =>`
      width: 100%;
      display: flex;
      margin-left: ${props.theme.spacing.base};
      flex-direction: column;
      @media only screen and (min-width: 320px) and (max-width: 767px) {
        width: 100%;
        margin-left: 0;
      }
`);
  